import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import { Link, useLocation, NavLink } from "react-router-dom";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// Dropdown => Rename all instances to use
type DropdownProps = {
  /** Lista de textos que aparencen en el dropdown, siendo el no.0 el index. */
  _text?: string[];
  /** Lista de urls a las que redireccionará el dropdown, siendo el no.0 el index. */
  _url?: string[];
  /** Tipo de dropdown a dibujar segun los tipos de buttons que existen. */
  _type?: "primary" | "secondary" | "clear";
  /** Si el dropdown reacciona con la URL actual (como si fuera NavLink). */
  _nav?: boolean;
} & _Base;

// ################################ RENDERING COMPONENT ################################
const _Dropdown = (props: DropdownProps) => {
  const location = useLocation();

  const curr =
    props._nav && location?.pathname.startsWith(props._url?.[0] || "/")
      ? "secondary"
      : "";

  // ------------------------------------------------------------------------------------ CLASSNAME FUNCTIONS
  const clsNameIndex = ({ isActive, isPending }) =>
    "index" + (isActive ? " current" : "") + (isPending ? " loading" : "");
  const clsName = ({ isActive, isPending }) =>
    "menu-item" + (isActive ? " current" : "") + (isPending ? " loading" : "");

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div className={"dropdown " + (curr || props._type)}>
      {props._nav ? (
        <NavLink className={clsNameIndex} to={props._url?.[0] || "/"} end>
          {props._text?.[0]}
        </NavLink>
      ) : (
        <Link className="index" to={props._url?.[0] || "/"}>
          {props._text?.[0]}
        </Link>
      )}

      <p className="to-set-max-size">
        {props._url
          ?.slice(1)
          .map((url, i) => (props._text?.[i + 1] || url) + "\n")}
      </p>

      <div className="menu">
        {props._url?.slice(1).map((url, i) =>
          props._nav ? (
            <NavLink key={i} className={clsName} to={url}>
              {props._text?.[i + 1] || url}
            </NavLink>
          ) : (
            <Link key={i} className="menu-item" to={url}>
              {props._text?.[i + 1] || url}
            </Link>
          )
        )}
      </div>
    </div>
  );
};

// ################################ STYLES ################################
const Dropdown = styled(_Dropdown).attrs(
  (props: DropdownProps): DropdownProps => {
    return {
      _text: ["Item", "Subitem"],
      _url: ["/", "/"],
      ...props,
    };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default Dropdown;
